import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface FireIconProps {
  size?: number
  color?: string
  className?: string
  title?: string
}

/**
 * Fire — the "Advanced" skill level. Mirrors the mobile Player Finder's
 * MaterialCommunityIcons `fire` glyph so both platforms read the same.
 */
const FireIcon: React.FC<FireIconProps> = ({
  size = 16,
  color = colors.PRIMARY,
  className,
  title,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable='false'
    >
      {title ? <title>{title}</title> : null}
      <path
        d='M12 23q-3.35 0-5.675-2.325T4 15q0-1.6.625-3.075T6.4 9.325L12 3.825l5.6 5.5q1.15 1.125 1.775 2.6T20 15q0 3.35-2.325 5.675T12 23Zm0-2q1.85 0 3.163-1.288T16.5 16.55q0-.9-.35-1.712t-1-1.438L12 10.2l-3.15 3.2q-.65.625-1 1.438T7.5 16.55q0 1.875 1.338 3.163T12 21Z'
        fill={color}
      />
    </svg>
  )
}

export default FireIcon
